[
  {
    "id": "refactor-journey",
    "title": "The Road to a Premium Developer Portfolio",
    "date": "2026-03-06",
    "excerpt": "A deep dive into the design philosophy and technical stack behind this portfolio refactor.",
    "tags": ["meta", "typescript", "design"],
    "content": "This portfolio was rebuilt from the ground up to demonstrate my commitment to high-quality code and aesthetic excellence. I'll be sharing more about the specific technical challenges soon..."
  }
]
